<!-- Selector -->
<rcp-dropdown-menu
  [disabled]="disabled"
  (clickButton)="show()"
  [color]="color"
  [icon]="icon"
  [label]="label"
  [menuPosition]="menuPosition"
  [blockOpen]="immediateActionIfOneOption && activeOptionTree?.length === 1"
>
  <!-- show back button if not in root -->
  @if (_options !== activeOptionTree) {
    <rcp-dropdown-menu-item [icon]="faAngleLeft" (click)="setActiveOptionTree(_options)" [preventClose]="true">
      {{ 'qz-back-zm' | translate }}
    </rcp-dropdown-menu-item>
  }

  <!-- options list -->
  @for (option of activeOptionTree; track option.label) {
    <rcp-dropdown-menu-item
      [icon]="option.icon"
      (click)="clickSelectorOption(option, $event)"
      [disabled]="option.disabled ?? false"
      [preventClose]="!!option.children"
    >
      <div class="flex align-center justify-space-between">
        <span class="ellipsis">
          {{ option.label }}
        </span>
        @if (!!option.children) {
          <fa-icon class="" [icon]="faAngleRight"></fa-icon>
        }
      </div>
    </rcp-dropdown-menu-item>
  }
</rcp-dropdown-menu>
